import { Moment } from "moment";
import Decimal from 'decimal.js';
import { Currency } from "./currency";
import { PaymentType } from "./payment-type";

export class SchoolInvoicePost {

    constructor(
        public invoiceNumber: string,
        public date: Moment,
        public amount: Decimal,
        public currency: Currency,
        public paymentType: PaymentType,
        public comment: string,
        public dueDate: Moment,
        public bookingId: number,
        public isValid: boolean
    ){}
}
